<template>
  <div class="detail-section">
    <mobile-breadcrumb v-if="isMobile" :title="detail.title"></mobile-breadcrumb>
    <div class="detail-box">
      <div :class="{'title':true, 'headline': isDownloadCenter}">
        {{detail.title}}
      </div>
      <div class="date" v-if="!isDownloadCenter">{{detail.time | dateFormat('yyyy-MM-dd')}}</div>
      <div class="line"></div>
      <div class="news-detail">
        <div class="ql-editor" v-html="detail.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileBreadcrumb from '@/components/MobileBreadcrumb.vue'
export default {
  computed: {
    isMobile () {
      return /Android|Windows Phone|iPhone|iPod/i.test(navigator.userAgent)
    },
    isDownloadCenter () {
      console.log(this.detail)
      return this.isMobile && this.detail.title === '下载中心'
    }
  },
  components: {
    MobileBreadcrumb
  },
  data () {
    return {
      detail: {}
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        this.init()
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const id = this.$route.query.id
      const type = this.$route.query.type
      id && this.getInfoDetail(id)
      type && this.getNoticeDetail(type)
    },
    getInfoDetail (id) {
      this.$axios.get(process.env.VUE_APP_jiaxingUrl + '/system/open/getTextById?id=' + id).then(res => {
        this.detail = res.data
      })
    },
    getNoticeDetail (type) {
      this.$axios.get(process.env.VUE_APP_jiaxingUrl + '/system/open/getNoticeById?id=' + type).then(res => {
        const data = res.data.data
        this.detail = {
          title: data.noticeTitle,
          time: data.createTime,
          text: data.noticeContent
        }
      })
    }
  }
}
</script>
<style lang="scss">
.detail-section {
  background: #F4F6F7;
  padding: 30px 0 50px;
}
.detail-box {
  width: 1200px;
  padding: 40px;
  margin: 0 auto;
  min-height: calc(100vh - 507px);
  box-shadow: 0 7px 29px 0 rgba(3, 6, 5, 0.08);
  border-radius: 20px;
  .title {
    font-size: 20px;
    font-weight: 600;
    line-height: 36px;
    color: #333;
    text-align: center;
  }
  .date {
    margin-top: 30px;
    font-size: 16px;
    color: #888;
    text-align: center;
  }
  .line {
    margin-top: 30px;
    width: 100%;
    height: 0;
    border-top: 1px dashed #c3c3c3;
  }
  .news-detail {
    margin-top: 50px;
    text-indent: 2em;
      line-height: 28px;
    img {
      max-width: 100%;
    }
  }
}

</style>
